var map = {
	"./icon_car.png": "a3fb",
	"./icon_car@2x.png": "09b6",
	"./icon_gift.png": "f09b",
	"./icon_gift@2x.png": "89f1",
	"./icon_shop.png": "7787",
	"./icon_shop@2x.png": "56ee",
	"./icon_tap.png": "d50a",
	"./icon_tap@2x.png": "2128",
	"./icon_woman.png": "737c",
	"./icon_woman@2x.png": "5a6a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aed1";